import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgAppListHeaderService, IMetricsStatusSummary, IMetricsStatusSummaryData } from "../ng-app-list-header.service";
import { NgToolsService } from "../../../ng-shared/ng-util/ng-tools.service";
import { NgAppFeatureToggleService } from "../../../ng-shared/ng-services/ng-app-feature-toggle.service";
import { Subscription } from "rxjs";
import * as lodash from "lodash";
import { TCI_APP_FEATURE_TYPE } from "@tci/common";
// See: https://swimlane.gitbook.io/ngx-charts/examples/pie-charts/advanced-pie-chart
// See: https://github.com/swimlane/ngx-charts/tree/6e0d63eda8c62b1c85b49b658e3d6576c34ef429
@Component({
    selector: "ng-app-list-state-summary",
    templateUrl: "./ng-app-list-state-summary.component.html",
    styleUrls: ["./ng-app-list-state-summary.component.less"]
})
export class NgAppListStateSummaryComponent implements OnInit, OnDestroy {
    totalApps: number;
    appStatuses: { name: string, value: number, percentage?: number }[];
    view: any[] = [214, 214];
    data: IMetricsStatusSummaryData[];
    timeCounter = 0;
    private appStatusFilterEnabled = false;

    private subscriptions: Subscription[] = [];
    private timerSubscription: Subscription;

    // options
    gradient = true;
    showLegend = false;
    showLabels = false;
    isDoughnut = true;
    animate = false;

    colorScheme = {
        domain: [
            "#18be5b", // Success
            "#d01b1a", // Error
            "#FAB632", // Warning
            "#727272", //  Not running
        ]
    };

    highlightEle: string;

    constructor(
        private headerService: NgAppListHeaderService,
        private toolsService: NgToolsService,
        private featureToggleService: NgAppFeatureToggleService
    ) {
        this.subscriptions.push(
            this.headerService.getSummaryDataSubject()
                .subscribe(res => {
                    this.initTimer();
                    this.totalApps = res.totalApps.value;

                    delete res.totalApps;
                    this.data = lodash.toArray(res);
                }),
            this.featureToggleService.getAppFeatures()
                .subscribe(res => this.appStatusFilterEnabled = res[TCI_APP_FEATURE_TYPE.APP_STATUS_FILTER].enabled
            ),
        );
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.cleanSubscriptions();
    }

    private cleanSubscriptions() {
        this.subscriptions.forEach(s => this.unsubscribe(s));
        this.unsubscribeTimer();
    }

    private unsubscribeTimer() {
        this.unsubscribe(this.timerSubscription);
    }

    private unsubscribe(s: Subscription) {
        try {
            s.unsubscribe();
        } catch (e) { }
    }

    private initTimer() {
        this.timeCounter = 0;
        const cb = () => this.timeCounter++;
        const minute = 60000;

        this.unsubscribeTimer();
        this.timerSubscription = this.toolsService.timer(cb, minute, minute).subscribe();
    }

    private onStatusSelect(status: IMetricsStatusSummaryData) {
        this.headerService.setStatusFilterSubject(status);
    }

    highlight($event: any) {
        this.highlightEle = $event.value.name;
    }

    unhighlight() {
        delete this.highlightEle;
    }
}
